import { CampaignTypesCard } from '@/components';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Highlights } from './Highlights';
import { ShowsCard } from './ShowsCard';
import { cardFullWidth } from '@/utils/styleUtils';
import { CustomPageHeading } from './CustomPageHeading';
import { useDerivedNetworkContext } from '@/context';

const SinglePayoutPage = () => {
  const { year, month } = useParams();
  /*
    this will never happen in theory since this component only renders for
    the /:year/:month path
  */
  if (!year || !month) throw new Error('Both year and month parameters are required');

  const { selectedNetwork } = useDerivedNetworkContext();
  const navigate = useNavigate();

  const isValidMonth = month && !isNaN(Date.parse(month));

  useEffect(() => {
    if (!isValidMonth) {
      // navigate back to main payouts page if month param is misformatted
      navigate(`/${selectedNetwork.id}/payouts/${year}`, { replace: true });
    }
  }, [isValidMonth, navigate, selectedNetwork.id, year]);

  return (
    <>
      <CustomPageHeading selectedNetwork={selectedNetwork} year={year} month={month} />

      <section className="grid grid-cols-12 gap-6 auto-rows-[400px, _1fr)]">
        <Highlights selectedNetwork={selectedNetwork} year={year} month={month} />
        <ShowsCard selectedNetwork={selectedNetwork} year={year} month={month} />
        <CampaignTypesCard className={cardFullWidth} />
      </section>
    </>
  );
};

export default SinglePayoutPage;
